import { Chip } from "@mui/material";
import { useTranslation } from "next-i18next";
import { ISearchUnderlying } from "src/api/client/search-autocomplete.api.types";
import { EnumSecurityType } from "src/types/common-enum";

export const UnderlyingBadge = ({ securityType }: Pick<ISearchUnderlying, "securityType">) => {
    const { t } = useTranslation("common");

    switch (securityType) {
        case EnumSecurityType.Stock:
            return <Chip sx={{ px: 2 }} label={t("stock")} color="green" variant="filled" size="large" />;
        case EnumSecurityType.ETF:
            return <Chip sx={{ px: 2 }} label={t("etf")} color="lilac" variant="filled" size="large" />;
        case EnumSecurityType.Bond:
        case EnumSecurityType.Derivatives:
        case EnumSecurityType.Wikifolios:
        default:
            return null;
    }
};
